<script>
	import { onMount } from 'svelte';
	import { push, pop, replace } from 'svelte-spa-router';
	import mainImage from '../img/main.png';

	// Import routes components
	import Home from './Home.svelte';
	import About from './About.svelte';
	import Academic from './Academic.svelte';
	import Stack from './Stack.svelte';
	import Portfolio from './Portfolio.svelte';
	import Career from './Career.svelte';
	import Contact from './Contact.svelte';

	// Route configuration
	export const routes = {
		'/': Home,
		'/About': About,
		'/Academic': Academic,
		'/Stack': Stack,
		'/Portfolio': Portfolio,
		'/Career': Career,
		'/Contact': Contact
	};
	
	// Brief descriptions for each section
	const menuSections = [
		{
			name: "About",
			description: "Learn more about me, my journey, and what drives me as a developer.",
			path: "#/About"
		},
		{
			name: "Academic",
			description: "My educational background and academic achievements.",
			path: "#/Academic"
		},
		{
			name: "Career",
			description: "My professional experience and work history in the tech industry.",
			path: "#/Career"
		},
		{
			name: "Portfolio",
			description: "A showcase of my projects and development work.",
			path: "#/Portfolio"
		},
		{
			name: "Stack",
			description: "Technologies and programming languages I work with.",
			path: "#/Stack"
		},
		{
			name: "Contact",
			description: "Get in touch with me for opportunities or questions.",
			path: "#/Contact"
		}
	];

	// Function to handle navigation
	function navigateTo(path) {
		push(path);
	}
</script>

<div class="container">
	<div class="hero-section">
		<span class="titleMain">Welcome</span>
		<img class="mainImg" src={mainImage} alt="Main" />
		<p class="subtitle">Hi there,<br>I'm Aiden, a passionate Front-end Developer<br>Let me introduce myself now</p>
		<div class="scroll-indicator">
			<span>Scroll to explore</span>
			<div class="arrow-down"></div>
		</div>
	</div>
	
	<div class="sections-preview">
		<h2>Explore My Portfolio</h2>
		
		<div class="sections-grid">
			{#each menuSections as section}
				<div class="section-card">
					<h3>{section.name}</h3>
					<p>{section.description}</p>
					<a href={section.path} class="section-link" on:click|preventDefault={() => navigateTo(section.path.replace('#', ''))}>
						View {section.name} <span class="arrow">→</span>
					</a>
				</div>
			{/each}
		</div>
	</div>
</div>

<style>
	.container {
		display: flex;
		flex-direction: column;
		align-items: center;
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 20px;
		margin-top: 10rem;
	}

	.hero-section {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 80vh;
		width: 100%;
		text-align: center;
	}

	.titleMain {
		font-size: var(--font-size-title, 3rem);
		font-weight: bold;
		color: var(--color-text, #000000);
		margin-bottom: 1.5rem;
	}

	.mainImg {
		width: 100px;
		margin-bottom: 2rem;
	}
	
	.subtitle {
		font-size: 1.2rem;
		margin-top: 3rem;
		margin-bottom: 3rem;
		color: #ebebeb;
	}
	
	.scroll-indicator {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-top: 2rem;
		color: #c2c2c2;
		font-size: 1rem;
	}
	
	.arrow-down {
		width: 20px;
		height: 20px;
		border-right: 2px solid #888;
		border-bottom: 2px solid #888;
		transform: rotate(45deg);
		margin-top: 10px;
		animation: bounce 2s infinite;
	}
	
	@keyframes bounce {
		0%, 20%, 50%, 80%, 100% {
			transform: translateY(0) rotate(45deg);
		}
		40% {
			transform: translateY(-10px) rotate(45deg);
		}
		60% {
			transform: translateY(-5px) rotate(45deg);
		}
	}
	
	.sections-preview {
		width: 100%;
		padding: 4rem 0;
	}
	
	.sections-preview h2 {
		text-align: center;
		font-size: 2rem;
		margin-bottom: 3rem;
		color: var(--color-text, #000000);
	}
	
	.sections-grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
		gap: 5rem;
	}
	
	.section-card {
		background-color: #2b2b2b;
		border-radius: 8px;
		padding: 2rem;
		transition: transform 0.3s ease, box-shadow 0.3s ease;
		height: 100%;
		display: flex;
		flex-direction: column;
	}
	
	.section-card:hover {
		transform: translateY(-5px);
		box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
	}
	
	.section-card h3 {
		font-size: 1.5rem;
		margin: 0 0 1rem 0;
		color: var(--color-text, #000000);
	}
	
	.section-card p {
		color: #a2a2a2;
		margin-bottom: 1.5rem;
		flex-grow: 1;
	}
	
	.section-link {
		display: inline-flex;
		align-items: center;
		color: #a2a2a2;
		text-decoration: none;
		font-weight: 500;
		padding: 0.5rem 0;
		border-bottom: 2px solid transparent;
		transition: border-color 0.2s ease;
		margin-top: auto;
	}
	
	.section-link:hover {
		border-color: #a2a2a2;
	}
	
	.arrow {
		margin-left: 0.5rem;
		transition: transform 0.2s ease;
	}
	
	.section-link:hover .arrow {
		transform: translateX(5px);
	}
	
	/* Responsive design */
	@media (max-width: 768px) {
		.hero-section {
			height: 70vh;
		}
		
		.titleMain {
			font-size: 2.5rem;
		}
		
		.sections-grid {
			grid-template-columns: 1fr;
		}
	}
</style>